module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-regular-pro-ccb0e187b87159f405e37fdb889cc138.ttf";